module.exports = __webpack_public_path__ + "static/media/starUnselected.5169f79e.png";